import React from 'react'
import cn from 'classnames'

import './FormControl.less'

type FormControlProps = {
  as?: 'input' | 'textarea'
  className?: string
  [key: string]: unknown
}

const FormControl = React.forwardRef<HTMLInputElement | HTMLTextAreaElement, FormControlProps>(
  ({ as, className, ...rest }, ref) => {
    const Tag = (as || 'input') as React.ElementType
    return <Tag ref={ref} className={cn('form-control', className as string)} {...rest} />
  }
)

FormControl.displayName = 'FormControl'

export default FormControl
